<template>
  <div>
    <gj-table
        ref="gjTable"
        name="lowStorageRank"
        :loading="loading"
        :index="false"
        :data="tableData"
        :columns="columns"
        :adapt-height="false"
        :height="534"
        row-id="id"
        :tree-config="{transform: false, lazy: true, hasChild: 'hasChild',loadMethod: loadChildrenMethod}"
    >

      <template v-slot:header:asin>
        <span v-if="type === 'asin'">ASIN</span>
        <span v-if="type === 'variationAsin'">父ASIN/子ASIN</span>
        <span v-if="type === 'msku'">MSKU</span>
      </template>

      <template v-slot:index="{row,index}">
        {{rank(row,index)}}
      </template>

<!--      <template v-slot:header:product>-->
<!--        <app-dashboard-rank-product-header :type="type"></app-dashboard-rank-product-header>-->
<!--      </template>-->
<!--      -->
<!--      <template v-slot:product="{ index, row }">-->
<!--        <app-dashboard-rank-product-column-->
<!--            :type="type"-->
<!--            :row="row">-->
<!--        </app-dashboard-rank-product-column>-->
<!--      </template>-->

      <template v-slot:picture="{row}">
        <app-dashboard-rank-picture-column
            :row="row"
            :groupType="type"
        ></app-dashboard-rank-picture-column>
      </template>

      <template v-slot:asin="{row}">
        <template v-if="type !== 'msku'">
          <gj-link v-if="row.hasChild" :href="row.variationAsinUrl" target="_blank">{{row.variationAsin | defaultShow}}</gj-link>
          <gj-link v-else :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
        </template>
        <span v-else>{{row.msku | defaultShow}}</span>
      </template>

      <template v-slot:availableDays="{row}">
        <span class="colorGreen">{{row.availableDays | defaultShow}}</span>
      </template>

      <template #empty v-if="!showStoreMask">
        <div></div>
      </template>

    </gj-table>
  </div>
</template>

<script>
  import {queryMixin} from "../../../../../../minxins";
  import {getSaleLowRank, getStorageLowRank} from "../../../../../../api/dashboard";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {countryMarketParams} from "../../../../../../utils/common";
  import AppDashboardRankProductHeader from "./components/dashboard-rank-product-header";
  import AppDashboardRankProductColumn from "./components/dashboard-rank-product-column";
  import AppDashboardRankPictureColumn from "./components/dashboard-rank-picture-column";
  import {rankMixin} from "@/views/modules/home/components/rank/components/mixin";

  export default {
    name: "app-dashboard-storage-low-rank",
    components: {AppDashboardRankPictureColumn, AppDashboardRankProductColumn, AppDashboardRankProductHeader},
    mixins: [queryMixin, rankMixin],
    data() {
      return {
        rankName: 'storageLow',
        tableData: [],
        columns: [
          {id: 'index', header: '排名', field: 'slot:index', width: '60px'},
          {id: 'picture', header: '图片', field: 'slot:picture', width: '50px'},
          {id: 'listingTitle', header: '商品标题', field: 'listingTitle', minWidth: '300px', overflowLine: 2},
          {id: 'asin', header: 'slot:asin', field: 'slot:asin', width: '140px'},
          // {id: 'product', header: 'slot:product', field: 'slot:product', minWidth: '300px'},
          {id: 'sale', header: '7天销量', field: 'saleQuantity', width: '70px', align: 'right', sortable: false},
          {id: 'sales', header: '7天销售额', field: 'sales', prefix: 'currencySymbol', align: 'right', width: '110px', sortable: false},
          {id: 'return', header: '7天退款量', field: 'refundQuantity', align: 'right', width: '90px', sortable: false},
          // {id: 'fba', header: 'FBA库存', field: 'inventoryQuantity', align: 'right', width: '80px', sortable: false},
          {id: 'fba', header: 'FBA可售', field: 'inventoryQuantity', align: 'right', width: '80px', sortable: false},
          {id: 'inventoryFbmQuantity', header: 'FBM可售', field: 'inventoryFbmQuantity', align: 'right', width: '80px', sortable: false},
          // {id: 'saleDays', header: '可售周转', field: 'availableDays', align: 'right', width: '75px', sortable: false},
          {id: 'saleDays', header: 'FBA可售周转', field: 'slot:availableDays', align: 'right', width: '100px', sortable: false},
          {id: 'availableDaysFbm', header: 'FBM可售周转', field: 'availableDaysFbm', align: 'right', width: '100px', sortable: false},
        ],
      }
    },

    methods: {
      //异步获取父asin展开数据
      loadChildrenMethod ({ row }) {
        return getStorageLowRank({
          currency: this.dashboardCurrency,
          groupType: 'asin',
          month:this.month,
          variationAsin: row.variationAsin,
          marketIds: row.marketId
        })
      },
      $gjQuery() {
        if(!this.showStoreMask){
          return
        }
        // 查询
        this.loading = true;
        getStorageLowRank({
          currency: this.dashboardCurrency,
          groupType: this.type,
          month:this.month,
          countrys: this.countryMarket.countryIds.join(','),// 国家
          marketIds: this.countryMarket.marketIds.join(','),// 店铺
        })
          .then((data) => {
            this.tableData = data || [];
            if(this.type === 'variationAsin'){
              this.tableData.forEach((r,index)=>{
                r.hasChild = true;
              })
            }
          })
          .complete(() => this.loading = false);
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "common";
  /deep/ .vxe-table--render-default .vxe-cell{
    padding-left: 10px;
  }
</style>

